/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    const editableNumberOfBlocksNodeIds = [13, 16, 18, 19, 20, 21, 22, 24,25, 26, 27, 28];
    const doNotNeedMftSerialNodeIds = [6, 10, 13, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27];
    const canUseSonNodeIds = [8, 11, 12, 13, 14, 15, 16, 18, 19, 22, 24, 25];
    const srtNodesIds = [16, 19, 22, 24, 25];

    export const MAG_NETWORK_NODE_TYPE: number = 10;
    export const VTS_NETWORK_NODE_TYPE: number = 13;
    export const TNS_NETWORK_NODE_TYPE: number = 14;
    export const VTD_NETWORK_NODE_TYPE: number = 18;

    export interface INetworkNodeType {
        name: string;
        numInterfaces: number;
        id: number;
        vendor: string;
        href: string;
        interfaceDefs: NetworkInterfaceDef[];
        manifest: Object;
        dnsModelName: string;
        isNumberOfBlocksEditable: () => boolean;
        isIntinor: () => boolean;
        needsMftSerial: () => boolean;
        canUseSon: () => boolean;
        isSrt: () => boolean;
        isSrtCaller: () => boolean;
        containsStartPort: () => boolean;
        getTextForSpecificsTab: () => string;
        hasSignalInterfaceDNS: () => boolean;
        canBeRedundant: () => boolean;
    }
    
    export interface INetworkNodeTypeHalList extends IHalEmbedded<NetworkNodeType> {
        networkNodeTypes: INetworkNodeTypeHalElement[];
    }
    
    export interface INetworkNodeTypeHalElement extends IHalElement<NetworkNodeType> {
        name: string;
        numInterfaces: number;
    }
    
    export class NetworkNodeType implements INetworkNodeType {
        public name: string;
        public numInterfaces: number;
        public id: number;
        public vendor: string;
        public href: string;
        public interfaceDefs: NetworkInterfaceDef[];
        public manifest: Object;
        public dnsModelName: string;

        /*
         * Factory method to create an object with params.
         * @param {string} name - Name of this particular node type
         * @param {number} numInterfaces - The number of available network interfaces
         * @param {string} href - Unique identification of this resource
         */
        public static Factory(name: string, numInterfaces: number, href: string): NetworkNodeType {
            let nnt: NetworkNodeType = new NetworkNodeType();
            nnt.name = name;
            nnt.numInterfaces = numInterfaces;
            nnt.href = href;
            return nnt;
        }

        public static Empty(): NetworkNodeType {
            return new NetworkNodeType();
        }

        public static Copy(networkNodeType: INetworkNodeType): NetworkNodeType {
            const newNetworkNodeType: NetworkNodeType = new NetworkNodeType();
            newNetworkNodeType.name = networkNodeType.name;
            newNetworkNodeType.numInterfaces = networkNodeType.numInterfaces;
            newNetworkNodeType.id = networkNodeType.id;
            newNetworkNodeType.href = networkNodeType.href;
            newNetworkNodeType.interfaceDefs = networkNodeType.interfaceDefs;
            newNetworkNodeType.manifest = networkNodeType.manifest;
            newNetworkNodeType.dnsModelName = networkNodeType.dnsModelName;
            return newNetworkNodeType;
        }

        /**
         * NetworkNodeType's empty constructor for automatic conversion from
         * REST data.
         * 
         */
        constructor() {

            if (this.id === undefined && (this.href !== undefined && this.href !== '')) {
                this.id = Common.Utils.idFromHref(this.href);
            }
        }

        public isIntinor(): boolean{
            console.log("this.id === 28 --> ", this.id === 28);
            return this.id === 28;
        }

        public isNumberOfBlocksEditable(): boolean {
            return editableNumberOfBlocksNodeIds.indexOf(this.id) > -1;
        }

        public needsMftSerial(): boolean {
            return doNotNeedMftSerialNodeIds.indexOf(this.id) == -1;
        }

        public canUseSon(): boolean {
            return canUseSonNodeIds.indexOf(this.id) > -1;
        }

        public hasSignalInterfaceDNS(): boolean {
            return this.id && (this.id === 8 || this.id === 11);
        }

        public isSrt(): boolean {
            return srtNodesIds.indexOf(this.id) > -1;
        }

        public isSrtCaller(): boolean {
            return this.id && (this.id === 24 || this.id === 24);
        }

        public containsStartPort(): boolean {
            return this.isSrt();
        }

        public getTextForSpecificsTab(): string {
            switch (this.id) {
                case 9:
                    return 'RX8200';
                case 13:
                    return 'VTS';
                case 16:
                    return 'SRT-RX';
                case 18:
                    return 'VTSD';
                case 20:
                    return 'VSRT-RX';
                case 21:
                    return 'VSRT-TX';
                case 22:
                    return 'SRT-TX';
                case 24:
                    return 'SRT-TX';
                case 25:
                    return 'SRT-RX';
                case 26:
                   return 'VSRT-RX';
                case 27:
                    return 'VSRT-TX';
            }
            return '';
        }

        /**
         * Method to check if a node allows redundancy
         *
         * @return boolean true if allows redundancy false otherwise
         */
        public canBeRedundant(): boolean {
            const REDUNDANT_DEVICES_LIST = ['ATEME-DR5000'];
            return REDUNDANT_DEVICES_LIST.indexOf(this.name) > -1
        }

        public static getVirtualizableDevicesTypeNames(): string[] {
            return [NetworkNodeType.SRT_GW_RX_LSTN, NetworkNodeType.SRT_GW_TX_LSTN];
        }


        public static SRT_GW_RX_LSTN: string = "SRT-GW-RX-LSTN";
        public static SRT_GW_TX_LSTN: string = "SRT-GW-TX-LSTN";
        public static SRT_GW_TX_CALL: string = "SRT-GW-TX-CALL";
        public static SRT_GW_RX_CALL: string = "SRT-GW-RX-CALL";
        public static VIRT_SRT_RX_CALL: string = "VIRT-SRT-RX-CALL";
        public static VIRT_SRT_RX_LSTN: string = "VIRT-SRT-RX-LSTN";
        public static FLEX_IO: string = "FLEX-IO";


    }

    export class NetworkNodeTypeVendor {
        public static FLEXO: string = "FLEXO";
        public static MVP: string = "MVP";
        public static OTHER: string = "OTHER";
    }

    export class NetworkInterfaceDef {
        public name: string;
        public type: Models.NetworkInterfaceType;
    }
}
